import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Heart, ShoppingCart, MapPin, Plus, Trash2 } from 'lucide-react';
import Navbar from '../components/Navbar';
import { useWishlist } from '../context/WishlistContext';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

const CAT_EMOJI = { sand: '🏖️', cement: '🧱', iron: '⚙️', bricks: '🔶', long_bricks: '🟧', short_bricks: '🟫', other: '📦' };
const CAT_COLOR = { sand: '#F59E0B', cement: '#6B7280', iron: '#374151', bricks: '#DC2626', long_bricks: '#EA580C', short_bricks: '#92400E', other: '#6B7280' };

export default function Wishlist() {
  const { wishlist, toggle } = useWishlist();
  const { addToCart } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleAddToCart = (mat) => {
    if (!user) { toast.info('Login to add to cart'); navigate('/login'); return; }
    if (user.role !== 'customer') { toast.warning('Only customers can order'); return; }
    // Build a minimal owner object from saved wishlist data
    addToCart(mat, { _id: mat.ownerId, shopName: mat.shopName }, 1, null);
    toast.success(`${mat.name} added to cart!`);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--page-bg)' }} className="page-with-bottom-nav">
      <Navbar />
      <div style={{ maxWidth: 1000, margin: '0 auto', padding: '24px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
          <Heart size={22} color="var(--red)" fill="var(--red)" />
          <h1 style={{ fontSize: 22, fontWeight: 700 }}>My Wishlist</h1>
          <span style={{ background: 'var(--red)', color: 'white', borderRadius: '50%', width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700 }}>{wishlist.length}</span>
        </div>

        {wishlist.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '80px 20px', background: 'white', borderRadius: 16, boxShadow: 'var(--shadow)' }}>
            <Heart size={64} color="var(--gray-border)" style={{ marginBottom: 16 }} />
            <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Your wishlist is empty</h2>
            <p style={{ color: 'var(--gray)', fontSize: 14, marginBottom: 24 }}>Save materials you like for easy ordering later</p>
            <Link to="/shops" className="btn-primary" style={{ padding: '12px 28px' }}>Browse Materials</Link>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
            {wishlist.map(mat => {
              const color = CAT_COLOR[mat.category] || 'var(--orange)';
              return (
                <div key={mat._id} style={{ background: 'white', borderRadius: 14, boxShadow: 'var(--shadow)', overflow: 'hidden' }}>
                  <div style={{ padding: '10px 14px', background: color + '10', display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontSize: 22 }}>{CAT_EMOJI[mat.category] || '📦'}</span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 700, fontSize: 14, fontFamily: 'var(--font-main)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{mat.name}</div>
                      {mat.brand && <div style={{ color: 'var(--gray)', fontSize: 12 }}>{mat.brand}</div>}
                    </div>
                    <button onClick={() => toggle(mat, {})} style={{ background: '#FEF2F2', border: 'none', borderRadius: 8, padding: 6, cursor: 'pointer', color: 'var(--red)', display: 'flex' }}>
                      <Trash2 size={14} />
                    </button>
                  </div>
                  <div style={{ padding: '12px 14px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                      <span style={{ fontWeight: 700, fontSize: 18, color: 'var(--orange)' }}>₹{mat.price?.toLocaleString()}</span>
                      <span style={{ fontSize: 12, color: 'var(--gray)' }}>/ {mat.unit}</span>
                    </div>
                    {mat.shopName && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 4, color: 'var(--gray)', fontSize: 12, marginBottom: 12 }}>
                        <MapPin size={11} /> {mat.shopName}
                      </div>
                    )}
                    <div style={{ display: 'flex', gap: 8 }}>
                      <Link to={`/shops/${mat.ownerId}`} style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '8px', borderRadius: 8, border: '1.5px solid var(--gray-border)', background: 'white', color: 'var(--dark)', fontSize: 12, fontWeight: 600, textDecoration: 'none' }}>
                        View Shop
                      </Link>
                      <button onClick={() => handleAddToCart(mat)} className="btn-primary" style={{ flex: 1, justifyContent: 'center', padding: '8px', fontSize: 12 }}>
                        <ShoppingCart size={13} /> Add to Cart
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
